import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { awaitpxajk6hm43eq as await_0 } from './afterTimeout.js.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___get_isFailure__impl__jpiriv2yxkms7bg2hpm as _Result___get_isFailure__impl__jpiriv,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  contains2el4s70rdq4ld as contains,
  split2bvyvnrlcifjv as split,
  trim11nh7r46at6sx as trim,
  splitToSequence1zhgbvnxlhat1 as splitToSequence,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  filter184huxd00uyfg as filter,
  mapsbvh18eqox7a as map,
} from '../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  HttpMethod_GET_getInstance1esunrp6hgoe5 as HttpMethod_GET_getInstance,
  RequestBodyTextpvofjwd95b3y as RequestBodyText,
  RequestBodyFile26cfvm0aih79m as RequestBodyFile,
  RequestBodyBlob1w7e8wxebrdro as RequestBodyBlob,
  RequestBlockedException1rsmv019vjn6n as RequestBlockedException,
  ConnectionException1wjs7wwnknnfm as ConnectionException,
} from './fetch.mjs';
import { numberToLong2pakxeg38estk as numberToLong } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Default_getInstance27jodt8hd1bac as Default_getInstance,
  infoOrAbove10o4ftgq7f7ui as infoOrAbove,
} from './debugger.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { endsWith3cq61xxngobwh as endsWith } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { withTimeoutOrNull1yc5m6zc7bl9o as withTimeoutOrNull } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Timeout.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { BasicListenable3uz4a8xs34a0h as BasicListenable } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_reachabilityProbeTimeout() {
  _init_properties_fetch_js_kt__b6zzi5();
  return reachabilityProbeTimeout;
}
var reachabilityProbeTimeout;
function get_cspRefusedOrigins() {
  _init_properties_fetch_js_kt__b6zzi5();
  return cspRefusedOrigins;
}
var cspRefusedOrigins;
function set_watchingCspViolations(_set____db54di) {
  _init_properties_fetch_js_kt__b6zzi5();
  watchingCspViolations = _set____db54di;
}
function get_watchingCspViolations() {
  _init_properties_fetch_js_kt__b6zzi5();
  return watchingCspViolations;
}
var watchingCspViolations;
function get_killAllSockets() {
  _init_properties_fetch_js_kt__b6zzi5();
  return killAllSockets;
}
var killAllSockets;
function toBlob(_this__u8e3s4, contentType) {
  contentType = contentType === VOID ? 'text/plain' : contentType;
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [_this__u8e3s4];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var o = {};
  o['type'] = contentType;
  return new Blob(tmp, o);
}
function RequestResponse$text$lambda$slambda($cont, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $cont;
    var tmp = this$0.wraps_1.response;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = (tmp instanceof Blob ? tmp : THROW_CCE()).text();
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value = yield* await_0(tmp_0 instanceof Promise ? tmp_0 : THROW_CCE(), $completion);
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    tmp0.resumeWith_rk9gbt_k$(tmp$ret$2);
    return Unit_instance;
  }), 1);
}
function RequestResponse$headers$delegate$lambda$lambda(it) {
  return contains(it, _Char___init__impl__6a9atx(58));
}
function RequestResponse$headers$delegate$lambda$lambda_0(it) {
  var s = split(it, [':'], VOID, 2);
  // Inline function 'kotlin.text.trim' call
  var this_0 = s.get_c1px32_k$(0);
  var tmp = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.text.trim' call
  var this_1 = s.get_c1px32_k$(1);
  var tmp$ret$1 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
  return to(tmp, tmp$ret$1);
}
function RequestResponse$_get_headers_$ref_4xwhd2() {
  return constructCallableReference((p0) => p0.get_headers_ef25jx_k$(), 1, 0, 132);
}
var RequestResponseClass;
function RequestResponse() {
  if (RequestResponseClass === VOID) {
    class $ {
      constructor(wraps) {
        this.wraps_1 = wraps;
        var tmp = this;
        tmp.headers$delegate_1 = lazy(() => {
          var tmp = splitToSequence(this.wraps_1.getAllResponseHeaders(), ['\r\n']);
          var tmp_0 = filter(tmp, RequestResponse$headers$delegate$lambda$lambda);
          return httpHeaders_0(map(tmp_0, RequestResponse$headers$delegate$lambda$lambda_0));
        });
      }
      get_status_jnf6d7_k$() {
        return this.wraps_1.status;
      }
      get_ok_kntnrv_k$() {
        return (this.wraps_1.status / 100 | 0) === 2;
      }
      *text_7k3n3e_k$($completion) {
        if (this.wraps_1.readyState === XMLHttpRequest.DONE) {
          var tmp = this.wraps_1.response;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_0 = (tmp instanceof Blob ? tmp : THROW_CCE()).text();
          return yield* await_0(tmp_0 instanceof Promise ? tmp_0 : THROW_CCE(), $completion);
        } else {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          return yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.initCancellability_shqc60_k$();
            var cont = cancellable;
            var handler = (ev) => {
              var tmp = get_AppScope();
              launch(tmp, VOID, VOID, RequestResponse$text$lambda$slambda(cont, this));
              return Unit_instance;
            };
            this.wraps_1.addEventListener('loadend', handler);
            cont.invokeOnCancellation_kffkqp_k$((it) => {
              this.wraps_1.removeEventListener('loadend', handler);
              return Unit_instance;
            });
            return cancellable.getResult_fck196_k$();
          };
        }
      }
      get_headers_ef25jx_k$() {
        var tmp0 = this.headers$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('headers', 1, tmp, RequestResponse$_get_headers_$ref_4xwhd2(), null);
        return tmp0.get_value_j01efc_k$();
      }
    }
    initMetadataForClass($, 'RequestResponse', VOID, VOID, VOID, [0]);
    RequestResponseClass = $;
  }
  return RequestResponseClass;
}
function httpHeaders(map) {
  var tmp;
  if (map === VOID) {
    // Inline function 'kotlin.collections.mapOf' call
    tmp = emptyMap();
  } else {
    tmp = map;
  }
  map = tmp;
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.apply' call
  var this_0 = new Headers();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = map.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var entry = _iterator__ex2g4s.next_20eer_k$();
    this_0.append(entry.get_key_18j28a_k$(), entry.get_value_j01efc_k$());
  }
  return this_0;
}
function httpHeaders_0(sequence) {
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.apply' call
  var this_0 = new Headers();
  var _iterator__ex2g4s = sequence.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var entry = _iterator__ex2g4s.next_20eer_k$();
    this_0.append(entry.first_1, entry.second_1);
  }
  return this_0;
}
function *platformFetch(url, method, headers, body, onUploadProgress, onDownloadProgress, $completion) {
  method = method === VOID ? HttpMethod_GET_getInstance() : method;
  headers = headers === VOID ? httpHeaders() : headers;
  body = body === VOID ? null : body;
  onUploadProgress = onUploadProgress === VOID ? null : onUploadProgress;
  onDownloadProgress = onDownloadProgress === VOID ? null : onDownloadProgress;
  watchCspViolations();
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.initCancellability_shqc60_k$();
    var cont = cancellable;
    var request = new XMLHttpRequest();
    var cancelled = {_v: false};
    var tmp0_safe_receiver = onUploadProgress;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var p = tmp0_safe_receiver;
      var tmp = request.upload;
      tmp.addEventListener('progress', (event) => {
        if (!(event instanceof ProgressEvent))
          THROW_CCE();
        var tmp = numberToLong(event.loaded);
        // Inline function 'kotlin.let' call
        var it = numberToLong(event.total);
        var tmp$ret$6 = it === 0n ? -1n : it;
        p(tmp, tmp$ret$6);
        return Unit_instance;
      });
    }
    var tmp1_safe_receiver = onDownloadProgress;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var p_0 = tmp1_safe_receiver;
      request.addEventListener('progress', (event) => {
        if (!(event instanceof ProgressEvent))
          THROW_CCE();
        var tmp = numberToLong(event.loaded);
        // Inline function 'kotlin.let' call
        var it = numberToLong(event.total);
        var tmp$ret$10 = it === 0n ? -1n : it;
        p_0(tmp, tmp$ret$10);
        return Unit_instance;
      });
    }
    // Inline function 'org.w3c.xhr.BLOB' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    request.responseType = 'blob';
    request.open(method.name_1, url);
    forEach(headers, (key, value) => {
      request.setRequestHeader(key, value);
      return Unit_instance;
    });
    request.onloadend = (ev) => {
      if (request.status >= 100) {
        var tmp0 = cont;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = new (RequestResponse())(request);
        var tmp$ret$16 = _Result___init__impl__xyqfz8(value);
        tmp0.resumeWith_rk9gbt_k$(tmp$ret$16);
      } else if (!cancelled._v) {
        var tmp = get_AppScope();
        launch(tmp, VOID, VOID, platformFetch$lambda$slambda(cont, url));
      }
      return Unit_instance;
    };
    var tmp2_subject = body;
    if (tmp2_subject == null) {
      request.send();
    } else {
      if (tmp2_subject instanceof RequestBodyBlob()) {
        request.setRequestHeader('Content-Type', body.content_1.type);
        request.send(body.content_1);
      } else {
        if (tmp2_subject instanceof RequestBodyFile()) {
          request.setRequestHeader('Content-Type', body.content_1.type);
          request.send(body.content_1);
        } else {
          if (tmp2_subject instanceof RequestBodyText()) {
            request.setRequestHeader('Content-Type', body.type_1);
            request.send(body.content_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    cont.invokeOnCancellation_kffkqp_k$((it) => {
      cancelled._v = true;
      request.abort();
      return Unit_instance;
    });
    return cancellable.getResult_fck196_k$();
  };
}
function platformWebSocket(url) {
  _init_properties_fetch_js_kt__b6zzi5();
  return new (WebSocketWrapper())(new WebSocket(url));
}
function watchCspViolations() {
  _init_properties_fetch_js_kt__b6zzi5();
  if (get_watchingCspViolations())
    return Unit_instance;
  set_watchingCspViolations(true);
  var tmp = document;
  tmp.addEventListener('securitypolicyviolation', watchCspViolations$lambda);
}
function forEach(_this__u8e3s4, action) {
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.js.asDynamic' call
  var keys = _this__u8e3s4.keys();
  var nextKey;
  do {
    nextKey = keys.next();
    if (nextKey.value != null && nextKey.value != undefined) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var nextValue = _this__u8e3s4.get(nextKey.value);
      action(nextKey.value, nextValue);
    }
  }
   while (!nextKey.done);
}
function *diagnoseFailure(url, $completion) {
  var origin = originOf(url);
  if (get_cspRefusedOrigins().contains_aljjnj_k$(origin))
    return RequestBlockedException().new_com_lightningkite_kiteui_RequestBlockedException_r2vfco_k$("This page's Content-Security-Policy does not allow connections to " + origin);
  if (mixedContentBlocked(url))
    return RequestBlockedException().new_com_lightningkite_kiteui_RequestBlockedException_r2vfco_k$('A page served over https may not request the insecure url ' + url);
  if (!window.navigator.onLine)
    return ConnectionException().new_com_lightningkite_kiteui_ConnectionException_w8iu0n_k$('The device reports that it is offline');
  return (yield* serverReachable(url, $completion)) ? RequestBlockedException().new_com_lightningkite_kiteui_RequestBlockedException_r2vfco_k$(origin + ' is reachable but the browser refused the request, which points at a CORS policy that ' + ('does not permit this origin (' + window.location.origin + '). The devtools console has the specifics.')) : ConnectionException().new_com_lightningkite_kiteui_ConnectionException_w8iu0n_k$('Could not reach ' + url);
}
var WebSocketWrapperClass;
function WebSocketWrapper() {
  if (WebSocketWrapperClass === VOID) {
    class $ {
      constructor(native, log) {
        log = log === VOID ? infoOrAbove(Default_getInstance().tag_ioihsw_k$('WS to ' + native.url)) : log;
        this.native_1 = native;
        this.log_1 = log;
        this.opened_1 = System_instance.now_2cba_k$();
        var tmp = this;
        var tmp_0 = get_killAllSockets();
        tmp.stopListeningToDebugKill_1 = tmp_0.addListener_6y9mct_k$(() => {
          println('Killing webSocket to ' + this.native_1.url + ' opened at ' + this.opened_1.toString());
          this.native_1.close(3008);
          return Unit_instance;
        });
        this.onClose_nz13c7_k$((it) => {
          this.stopListeningToDebugKill_1();
          return Unit_instance;
        });
        var tmp0_safe_receiver = this.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var log_0 = tmp0_safe_receiver;
          this.onOpen_i39mgf_k$(() => {
            log_0.info_59mt0k_k$(['Opened.']);
            return Unit_instance;
          });
          this.onMessage_u48dtp_k$((it) => {
            log_0.log_iyb52q_k$(['onMessage ' + it]);
            return Unit_instance;
          });
          this.onBinaryMessage_hcii77_k$((it) => {
            log_0.log_iyb52q_k$(['onBinaryMessage ' + toString(it)]);
            return Unit_instance;
          });
          this.onClose_nz13c7_k$((it) => {
            log_0.info_59mt0k_k$(['Closed with code ' + it + '.']);
            return Unit_instance;
          });
        }
      }
      close_a2oca2_k$(code, reason) {
        return this.native_1.close(code, reason);
      }
      send_oy6aea_k$(data) {
        return this.native_1.send(data);
      }
      onOpen_i39mgf_k$(action) {
        this.native_1.addEventListener('open', (it) => {
          action();
          return Unit_instance;
        });
      }
      onMessage_u48dtp_k$(action) {
        this.native_1.addEventListener('message', (it) => {
          if (!(it instanceof MessageEvent))
            THROW_CCE();
          var tmp = it.data;
          var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            action(tmp0_safe_receiver);
          }
          return Unit_instance;
        });
      }
      onBinaryMessage_hcii77_k$(action) {
        this.native_1.addEventListener('message', (it) => {
          if (!(it instanceof MessageEvent))
            THROW_CCE();
          var tmp = it.data;
          var tmp0_safe_receiver = tmp instanceof Blob ? tmp : null;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            action(tmp0_safe_receiver);
          }
          return Unit_instance;
        });
      }
      onClose_nz13c7_k$(action) {
        this.native_1.addEventListener('close', (it) => {
          action((it instanceof CloseEvent ? it : THROW_CCE()).code);
          return Unit_instance;
        });
      }
    }
    initMetadataForClass($, 'WebSocketWrapper');
    WebSocketWrapperClass = $;
  }
  return WebSocketWrapperClass;
}
function originOf(url) {
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = (new URL(url, window.location.href)).origin;
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  var tmp0 = tmp;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.getOrDefault' call
    if (_Result___get_isFailure__impl__jpiriv(tmp0)) {
      tmp$ret$4 = url;
      break $l$block;
    }
    tmp$ret$4 = _Result___get_value__impl__bjfvqg(tmp0);
  }
  return tmp$ret$4;
}
function mixedContentBlocked(url) {
  _init_properties_fetch_js_kt__b6zzi5();
  if (!(window.location.protocol === 'https:'))
    return false;
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = new URL(url, window.location.href);
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp;
  var tmp0_elvis_lhs = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var parsed = tmp_1;
  if (!(parsed.protocol === 'http:'))
    return false;
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var host = parsed.hostname.toLowerCase();
  return !(host === 'localhost') && !endsWith(host, '.localhost') && !(host === '127.0.0.1') && !(host === '[::1]') && !(host === '::1');
}
function *serverReachable(url, $completion) {
  var tmp = get_reachabilityProbeTimeout();
  var tmp0_elvis_lhs = yield* withTimeoutOrNull(tmp, serverReachable$slambda(url), $completion);
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function httpHeaders_1(list) {
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.apply' call
  var this_0 = new Headers();
  var _iterator__ex2g4s = list.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var entry = _iterator__ex2g4s.next_20eer_k$();
    this_0.append(entry.first_1, entry.second_1);
  }
  return this_0;
}
function platformFetch$lambda$slambda($cont, $url) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $cont;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = yield* /*#__NOINLINE__*/diagnoseFailure($url, $completion);
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.resumeWith_rk9gbt_k$(tmp$ret$1);
    return Unit_instance;
  }), 1);
}
function watchCspViolations$lambda(event) {
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.js.asDynamic' call
  var violation = event;
  if (violation.effectiveDirective == 'connect-src') {
    if (get_cspRefusedOrigins().get_size_woubt6_k$() >= 20) {
      get_cspRefusedOrigins().removeAt_6niowx_k$(0);
    }
    var tmp = get_cspRefusedOrigins();
    var tmp_0 = violation.blockedURI;
    tmp.add_utx5q5_k$(originOf((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE()));
  }
  return Unit_instance;
}
function serverReachable$slambda($url) {
  return constructCallableReference(($this$withTimeoutOrNull, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    try {
      var tmp_0 = window;
      // Inline function 'org.w3c.fetch.NO_CORS' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'org.w3c.fetch.NO_STORE' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp9 = 'no-store';
      // Inline function 'org.w3c.fetch.RequestInit' call
      var headers = undefined;
      var body = undefined;
      var referrer = undefined;
      var referrerPolicy = undefined;
      var credentials = undefined;
      var redirect = undefined;
      var integrity = undefined;
      var keepalive = undefined;
      var window_0 = undefined;
      var o = {};
      o['method'] = 'HEAD';
      o['headers'] = headers;
      o['body'] = body;
      o['referrer'] = referrer;
      o['referrerPolicy'] = referrerPolicy;
      o['mode'] = 'no-cors';
      o['credentials'] = credentials;
      o['cache'] = tmp9;
      o['redirect'] = redirect;
      o['integrity'] = integrity;
      o['keepalive'] = keepalive;
      o['window'] = window_0;
      yield* await_0(tmp_0.fetch($url, o), $completion);
      tmp = true;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof CancellationException()) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          tmp_1 = false;
        } else {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }), 1);
}
var properties_initialized_fetch_js_kt_ug494v;
function _init_properties_fetch_js_kt__b6zzi5() {
  if (!properties_initialized_fetch_js_kt_ug494v) {
    properties_initialized_fetch_js_kt_ug494v = true;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    reachabilityProbeTimeout = toDuration(5, DurationUnit_SECONDS_getInstance());
    // Inline function 'kotlin.collections.mutableListOf' call
    cspRefusedOrigins = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    watchingCspViolations = false;
    // Inline function 'kotlin.also' call
    var this_0 = BasicListenable().new_com_lightningkite_reactive_core_BasicListenable_biohma_k$();
    var it = this_0;
    // Inline function 'kotlin.js.asDynamic' call
    window.killAllSockets = () => {
      println('Killing all sockets');
      it.invokeAll_w2le0p_k$();
      return Unit_instance;
    };
    killAllSockets = this_0;
  }
}
//region block: exports
export {
  httpHeaders as httpHeaders3s629sxokj9k6,
  httpHeaders_1 as httpHeaders1p0c4h1mvk3o7,
  platformWebSocket as platformWebSocketv2zo0o1wd8e9,
  toBlob as toBlob3efqyqa0phgb9,
  platformFetch as platformFetch2wfqppk9q49jw,
};
//endregion

//# sourceMappingURL=fetch.js.mjs.map
